import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { loginBusiness } from '../api';
import { useAuth } from '../context/AuthContext';
import './BusinessAuthPage.css';

export default function BusinessLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await loginBusiness({ email, password });
      login(res.token, res.business, 'business');
      navigate('/business/dashboard');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="biz-auth-page">
      <div className="biz-auth-left">
        <div className="biz-auth-pitch">
          <div className="biz-auth-logo font-display">half<span>price</span>.ca</div>
          <h2>Welcome back. Your customers are waiting.</h2>
          <ul className="pitch-points">
            <li>✓ Manage your active deals</li>
            <li>✓ Track views and redemptions</li>
            <li>✓ Create new deals in minutes</li>
          </ul>
        </div>
      </div>
      <div className="biz-auth-right">
        <div className="auth-form-box fade-up">
          <h1>Business login</h1>
          <p className="auth-sub">Sign in to manage your deals and view performance.</p>
          {error && <div className="auth-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email address</label>
              <input type="email" className="form-control" placeholder="you@yourbusiness.ca" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input type="password" className="form-control" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary w-full" disabled={loading} style={{ justifyContent: 'center', padding: '13px' }}>
              {loading ? 'Signing in…' : 'Sign in →'}
            </button>
          </form>
          <p className="auth-switch">
            New to halfprice.ca? <Link to="/business/register">List your business free</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
